<template>
  <v-dialog
    v-model="display"
    color="primary"
    max-width="1000px"
  >
    <v-card
      class="user-lineup-dialog"
      color="background"
    >
      <user-score
        v-if="userMegaLeague"
        :user-mega-league="userMegaLeague"
      />
      <close-button
        @clickBtn="closeLineupDialog"
      />
      <v-card-text>
        <div
          v-if="isLoading"
          class="d-flex justify-center align-center"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
        <lineup
          v-else-if="userMegaLeague"
          :lineup="userMegaLeague.lineup"
          :game-week="userMegaLeague.gameWeek"
          :show-average-score="true"
        />
        <p v-else>
          {{ $t('user_lineup_dialog.unable_to_load_lineup') }}
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Lineup from '@/components/Lineup/Lineup.vue';
import UserMegaLeague from '@/models/MegaLeague/userMegaLeague';
import CloseButton from '@/components/CloseButton.vue';
import UserScore from "@/components/UserScore.vue";

export default {
  name: 'UserLineupDialog',
  components: {
    Lineup,
    CloseButton,
    UserScore,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    userMegaLeague: {
      type: UserMegaLeague,
      default: null,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    display: {
      get() { return this.modelValue; },
      set(display) { this.$emit('update:model-value', display); },
    },
  },
  methods: {
    closeLineupDialog() {
      this.display = false;
    },
  },
};
</script>
<style scoped lang="scss">
  .theme--dark.v-card{
    background-color: #192037;
  }
  .user-lineup-dialog{
    padding: 24px;
    .v-card__title{
      gap: 10px;
      padding: 24px;
      text-align: start;
    }
  }
</style>
